import { useAsyncDebounce } from 'react-table';
import React, { useState } from 'react';

import { StyledSearchIcon, StyledSearchInput } from './SearchFilter.styled';

const SearchFilter = ({ globalFilter, setGlobalFilter }) => {
  const [value, setValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  const onSearching = (event) => {
    const value = event.target.value;
    setValue(value);
    onChange(value);
  };

  return (
    <StyledSearchInput
      placeholder="Search..."
      startAdornment={<StyledSearchIcon />}
      value={value || ''}
      onChange={onSearching}
    />
  );
};

export default SearchFilter;
